import { PaymentLimitName } from '../@types/api';
import { PAYMENT_LIMIT_NAME } from './enums';

export const MESSAGES = {
  CONFIRM_DELETE: 'Are you sure you want to delete this item?',
  ACTIVATE_JACKPOT: 'Are you sure you want to activate this jackpot?',
  DEACTIVATE_JACKPOT: 'Are you sure you want to deactivate this jackpot?',
  CONFIRM_CANCEL_TICKET: 'Are you sure you want to cancel the selected ticket?',
};

export const PAYMENT_LIMIT_MESSAGES: Record<PaymentLimitName, (limitValue: number, newValue?: number) => string> = {
  [PAYMENT_LIMIT_NAME.MIN_AMOUNT_PER_TRANSACTION]: (limitValue) => `Minimum amount per transaction is ${limitValue}`,
  [PAYMENT_LIMIT_NAME.MAX_AMOUNT_PER_TRANSACTION]: (limitValue) => `Maximum amount per transaction is ${limitValue}`,
  [PAYMENT_LIMIT_NAME.MAX_DAILY_AMOUNT]: (limitValue, newValue) =>
    `Maximum daily amount is ${limitValue} (→ ${newValue})`,
  [PAYMENT_LIMIT_NAME.MAX_WEEKLY_AMOUNT]: (limitValue, newValue) =>
    `Maximum weekly amount is ${limitValue} (→ ${newValue})`,
  [PAYMENT_LIMIT_NAME.MAX_MONTHLY_AMOUNT]: (limitValue, newValue) =>
    `Maximum monthly amount is ${limitValue} (→ ${newValue})`,
  [PAYMENT_LIMIT_NAME.MAX_DAILY_COUNT]: (limitValue, newValue) =>
    `Maximum number of daily transactions is ${limitValue} (→ ${newValue})`,
  [PAYMENT_LIMIT_NAME.MAX_WEEKLY_COUNT]: (limitValue, newValue) =>
    `Maximum number of weekly transactions is ${limitValue} (→ ${newValue})`,
  [PAYMENT_LIMIT_NAME.MAX_MONTHLY_COUNT]: (limitValue, newValue) =>
    `Maximum number of monthly transactions is ${limitValue} (→ ${newValue})`,
  [PAYMENT_LIMIT_NAME.VERIFY_ALL]: () => 'Verify All',
  [PAYMENT_LIMIT_NAME.MASTER_WALLET_LOW_BALANCE]: () => 'Marketplace master wallet low balance',
};
